module.exports = __webpack_public_path__ + "staticcomp/img/content_3.0e02556.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/11/content_3.jpg
// module id = 1RjD
// module chunks = 39